import Page from "./Page";
import { Switch } from "react-router-dom";

import Login from "../auth/Login";
import Confirm from "../auth/Confirm";

import Sended from "../AccountBulkUpload/PrintDataSendet";
import ForgotPassword from "../auth/ForgotPassword";
import AdminLogin from "../auth/AdminLogin";
import Account from "../account/Account";
import PrivatePage from "./PrivatePage";
import AdminPage from "./AdminPage";
import AuthPage from "./AuthPage";
import Dashboard from "../dashboard/Dashboard";
import Manufacturers from "../manufacturers/Manufacturers";
import Profile from "../dashboard/Profile";
import UploadType from "../UploadType/index";
import AccountBulkUpload from "../AccountBulkUpload";
import ViewOrder from "../dashboard/ViewOrder";
import Order from "../dashboard/Order";

const Routes = () => {
  return (
    <section>
      <Switch>
        <AuthPage exact path="/login" title="Login" component={Login} />
        <AuthPage
          exact
          path="/auth/confirm"
          title="Confirm account"
          component={Confirm}
        />
        <Page
          exact
          path="/sended"
          title="PrintData Sended"
          component={Sended}
        />
        <PrivatePage
          exact
          path="/account/chooseupload"
          title="Choose Upload"
          component={UploadType}
        />

        <AuthPage
          exact
          path="/forgot-password"
          title="Forgot password"
          component={ForgotPassword}
        />
        <AuthPage
          exact
          path="/dashboard/login"
          title="Login"
          component={AdminLogin}
        />
        <PrivatePage
          exact
          path="/account"
          title="Account"
          component={Account}
        />
        <PrivatePage
          exact
          path="/account/bulkupload"
          title="Bulk Upload"
          component={AccountBulkUpload}
        />
        <AdminPage
          exact
          path="/dashboard"
          title="Dashboard"
          component={Dashboard}
        />
        <AdminPage exact path="/profile" title="Profile" component={Profile} />
        <AdminPage
          exact
          path="/dashboard/order/:id"
          title="Order"
          component={Order}
        />
        <AdminPage
          exact
          path="/dashboard/vieworder/:id"
          title="Order"
          component={ViewOrder}
        />
        <AdminPage
          exact
          path="/dashboard/manufacturers"
          title="Manufacturers"
          component={Manufacturers}
        />
      </Switch>
    </section>
  );
};

export default Routes;
